An array of attachments related to the candidate's profile.

This field is redacted and an empty list is returned when a candidate or job application is deleted.
For Apply with SEEK candidate profiles, only attachments with the `seekRoleCode` of `Resume` are returned.
